<main>
  <div *ngIf="this.eventCreatedBy === 'admin'">
    <admin-event></admin-event>
  </div>
  <div *ngIf="this.eventCreatedBy === 'teacher'">
    <teacher-event></teacher-event>
  </div>
  <div *ngIf="this.eventCreatedBy === 'student'">
    <student-event></student-event>
  </div>
</main>
